import type { AgentEventType } from "./types";

export const SUPPRESSION_WINDOW_MS = 60_000;
export const STALL_THRESHOLD_MS = 35_000;

const TRIGGER_DELAY_MAP: Partial<Record<AgentEventType, number>> = {
  answer_submitted_incorrect: 2500,
  stall: 0,
  activity_completed: 500,
  manual_help_requested: 0,
};

/**
 * Returns true if the agent is currently suppressed (within suppression window).
 */
export function isSuppressed(lastFiredAt: number | null): boolean {
  if (lastFiredAt === null) return false;
  return Date.now() - lastFiredAt < SUPPRESSION_WINDOW_MS;
}

/**
 * Returns the delay in milliseconds before firing for the given event type.
 */
export function getDelayMs(eventType: AgentEventType): number {
  return TRIGGER_DELAY_MAP[eventType] ?? 0;
}

/**
 * Returns true only for events that bypass suppression window.
 */
export function bypassesSuppression(eventType: AgentEventType): boolean {
  return eventType === "manual_help_requested";
}
